import { createContext, useContext } from 'react';
import type { User } from './auth';

export const UserContext = createContext<User | null>(null);
export const useUser = (): User => {
  const u = useContext(UserContext);
  if (!u) throw new Error('UserContext missing');
  return u;
};
